import './styles/main.css'

export default props => {
    return (
        <main>
            <h2>O que é o meu ip</h2>
            <p><strong>IP</strong> significa endereço do Protocolo de Internet. <strong>Um endereço IP é uma série exclusiva de números e letras atribuída a cada dispositivo conectado a uma rede de computadores, como a Internet</strong>. Esse rótulo identifica e diferencia os bilhões de dispositivos que usam a Internet, incluindo computadores, celulares, impressoras e um número crescente de dispositivos chamados de Internet das Coisas (IoT), como alto-falantes, geladeiras, sistemas de vigilância doméstica inteligentes e muito mais.</p>
            <hr/>
        </main>
    )
}